module.exports = __webpack_public_path__ + "media/03 ancestor.c59bfed1.mp3";